$.plugins.toggle = {
	_value: false,
	
	__init: function (config) {
		this.apply('widget', { label: config.label }).addClass('button toggle');
		
		if (config.span !== false) {
			this.span = $.element('span').html('&nbsp;').appendTo(this.label || this);
		}
		
		this.toggle(config.value === false ? false : true);
		
		this.on('click', this.toggle.bind(this), true);
	},
	
	is: function () {
		return this._value;
	},
	
	toggle: function (force) {
		this._value = typeof force === 'boolean' ? (!!force) : (!this._value);
		
		this.toggleClass('active', this._value);
		
		if (this.span) {
			this.span.toggleClass('active', this._value);
		}
		
		this.trigger('update', { value: this._value });
		
		return this;
	},
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/spingames/panel/js/toggle.js
 **/